var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.153 12.0653C41.7034 11.3035 40.8846 10.8359 40 10.8359C39.1154 10.8359 38.2966 11.3035 37.847 12.0653L7.84698 62.8986C7.39086 63.6715 7.38399 64.6296 7.82899 65.4089C8.27399 66.1882 9.10257 66.6693 10 66.6693H70C70.8974 66.6693 71.726 66.1882 72.171 65.4089C72.616 64.6296 72.6091 63.6715 72.153 62.8986L42.153 12.0653ZM40 18.2547L65.6217 61.6693H14.3783L40 18.2547ZM42.5 33.3359C42.5 31.9552 41.3807 30.8359 40 30.8359C38.6193 30.8359 37.5 31.9552 37.5 33.3359V43.3359C37.5 44.7166 38.6193 45.8359 40 45.8359C41.3807 45.8359 42.5 44.7166 42.5 43.3359V33.3359ZM40 56.6693C41.841 56.6693 43.3333 55.1769 43.3333 53.3359C43.3333 51.495 41.841 50.0026 40 50.0026C38.159 50.0026 36.6667 51.495 36.6667 53.3359C36.6667 55.1769 38.159 56.6693 40 56.6693Z",
    fill: "#FF0F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteWarning);
export default __webpack_public_path__ + "static/media/delete-warning.5c78815be77ace96be165437f96ee0f5.svg";
export { ForwardRef as ReactComponent };